import React, { useEffect } from 'react';
import Layout from '@/layout/Layout';
import TuitionFees from '@/components/page-parts/report-edit/TuitionFees';

const CoachingIncome = () => {
  useEffect(() => {
    (async () => {})();
  }, []);

  return (
    <>
      <Layout>
        <TuitionFees />
      </Layout>
    </>
  );
};

export default CoachingIncome;
